<template>
  <div>
    <b-row>
      <b-col xs="12">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <h3>Kullanıcılar</h3>
          <b-button v-b-modal.user variant="primary">+ Yeni Ekle</b-button>
        </div>
        <div class="mb-4"></div>
      </b-col>
    </b-row>
    <b-row>
      <b-table
          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="fields"
          :items="items"
          responsive
          show-empty>

        <template v-slot:table-busy>
          <div style="width: 100%; text-align:center;">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </template>

        <template v-slot:empty>
          <b-alert variant="warning" show>Henüz hiç kullanıcı eklememişsiniz, hemen yeni bir tane ekleyin!</b-alert>
        </template>

        <template v-slot:cell(actions)="data">
          <b-dropdown class="action-button" right>
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v"/>
            </template>
            <b-dropdown-item @click="edit(data.item)" class="dropdown-item-icon">
              <i class="fas fa-pen"></i>
              <span>Bilgileri Güncelle</span>
            </b-dropdown-item>
            <b-dropdown-item @click="openPasswordModal(data.item.id)" class="dropdown-item-icon">
              <i class="fas fa-pen"></i>
              <span>Şifre Değiştir</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deleteAction(data.item.id)" class="dropdown-item-icon">
              <i class="fas fa-trash"></i>
              <span>Sil</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
        <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows"
                      :per-page="pagination.perPage"/>
      </div>
    </b-row>

    <b-modal ref="user" id="user" @hide="resetUser">
      <b-form-group label="Ad Soyad">
        <b-form-input v-model="user.name"/>
      </b-form-group>
      <b-form-group label="GSM">
        <b-form-input v-model="user.phone" v-mask="'+90 (###) ### ## ##'"/>
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input v-model="user.email"/>
      </b-form-group>
      <b-form-group v-if="!user.id" label="Şifre">
        <b-form-input v-model="user.password"/>
      </b-form-group>

      <b-form-group :label="Rol" v-if="roles.includes('superadmin')" >
        <b-form-checkbox-group
            id="checkbox-group-2"
            v-model="user.roles"
            name="roles"
        >
          <b-form-checkbox value="admin">
            <span class="text-danger font-weight-bolder">{{ $t("Sistem Yetkilisi (Bayileri İzleyebilir)")}}</span>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>

<!--      <b-col xs="12" md="12" v-if="roles && roles.includes('superadmin')" class="align-items-center text-red font-weight-bolder my-4">-->
<!--        <input type="checkbox" checked-->
<!--               />-->
<!--          {{$t('Sistem Yetkilisi (Bayileri İzleyebilir ve Süper Yetkilidir)')}}-->
<!--      </b-col>-->


      <b-col xs="12" md="12">
        <b-form-group label="Gelir-Gider Görebilsin mi?">
          <b-form-select v-model="user.homepage_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>


      <b-col xs="12" md="12">
        <b-form-group label="Çalışan ve Maaşlar Bölümünü Görebilsin mi ?">
          <b-form-select v-model="user.salary_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Cari Bölümünü Görebilsin mi ?">
          <b-form-select v-model="user.client_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Hızlı Satış Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.fastsale_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Ürün Yönetimi Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.service_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

<!--      <b-col xs="12" md="12">-->
<!--        <b-form-group label="Yeni Ürün Siparişi Bölümünü Görebilsin mi?">-->
<!--          <b-form-select v-model="user.newservice_permission">-->
<!--            <b-form-select-option value="1">Evet</b-form-select-option>-->
<!--            <b-form-select-option value="0">Hayır</b-form-select-option>-->
<!--          </b-form-select>-->
<!--        </b-form-group>-->
<!--      </b-col>-->

      <b-col xs="12" md="12">
        <b-form-group label="Kasa Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.safe_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Raporlar Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.report_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Randevular Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.appointment_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

<!--      <b-col xs="12" md="12">-->
<!--        <b-form-group label="Kuaför Randevuları Bölümünü Görebilsin mi?">-->
<!--          <b-form-select v-model="user.coiffeurappointment_permission">-->
<!--            <b-form-select-option value="1">Evet</b-form-select-option>-->
<!--            <b-form-select-option value="0">Hayır</b-form-select-option>-->
<!--          </b-form-select>-->
<!--        </b-form-group>-->
<!--      </b-col>-->

      <b-col xs="12" md="12">
        <b-form-group label="SMS Bölümünü Görebilsin mi?">
          <b-form-select v-model="user.sms_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col xs="12" md="12">
        <b-form-group label="Tanımlamalar Görebilsin mi?">
          <b-form-select v-model="user.definition_permission">
            <b-form-select-option value="1">Evet</b-form-select-option>
            <b-form-select-option value="0">Hayır</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>

<!--      <b-col xs="12" md="12">-->
<!--        <b-form-group label="Ürünlere Beden ve Yıl Girebilsin mi?">-->
<!--          <b-form-select v-model="user.yearsize_permission">-->
<!--            <b-form-select-option value="1">Evet</b-form-select-option>-->
<!--            <b-form-select-option value="0">Hayır</b-form-select-option>-->
<!--          </b-form-select>-->
<!--        </b-form-group>-->
<!--      </b-col>-->

<!--      <b-col xs="12" md="12">-->
<!--        <b-form-group label="Cari Fotoğrafı Ekleyebilsin Mi?">-->
<!--          <b-form-select v-model="user.productimage_permission">-->
<!--            <b-form-select-option value="1">Evet</b-form-select-option>-->
<!--            <b-form-select-option value="0">Hayır</b-form-select-option>-->
<!--          </b-form-select>-->
<!--        </b-form-group>-->
<!--      </b-col>-->


      <template v-slot:modal-footer>
        <b-button @click="$refs.user.hide()">Kapat</b-button>
        <b-button @click="save()" variant="primary">Kaydet</b-button>
      </template>
    </b-modal>

    <b-modal ref="password" title="Şifre Güncelle" @hide="resetPassword">
      <b-form-group label="Yeni Şifre">
        <b-form-input v-model="password"/>
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button @click="$refs.password.hide()">Kapat</b-button>
        <b-button @click="savePassword()" variant="primary">Kaydet</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'Users',
  data() {
    return {
      id: '',
      password: '',
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
      fields: [
        {key: 'name', label: 'Ad Soyad'},
        {key: 'phone', label: 'Telefon'},
        {key: 'email', label: 'E-mail'},
        {key: 'actions', label: '', tdClass: 'text-right'},
      ],
      user: {
        name: '',
        phone: '',
        email: '',
        password: '',
        homepage_permission: 0,
        salary_permission: 0,
        roles:[],
      }
    }
  },
  props: ['companyid'],
  computed:{
    ...mapGetters(['roles'])
  },
  mounted(){
  },
  methods: {
    ...mapActions([
      'getUsers',
      'deleteUser',
      'createUser',
      'updateUser',
      'changeUserPassword',
        'getUser'
    ]),
    savePassword() {
      this.changeUserPassword({
        id: this.id,
        password: this.password,
      }).then(response => {
        this.success(response.data.message);
        this.$refs.password.hide();
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    resetPassword() {
      this.id = ''
      this.password = ''
    },
    openPasswordModal(id) {
      this.id = id;
      this.$refs.password.show();
    },
    save() {
      if (this.user.id) {
        const data = {
          id: this.user.id,
          name: this.user.name,
          email: this.user.email,
          phone: this.user.phone,
          homepage_permission: this.user.homepage_permission,
          salary_permission: this.user.salary_permission,
          service_permission: this.user.service_permission,
          fastsale_permission: this.user.fastsale_permission,
          newservice_permission: this.user.newservice_permission,
          safe_permission: this.user.safe_permission,
          client_permission: this.user.client_permission,
          report_permission: this.user.report_permission,
          appointment_permission: this.user.appointment_permission,
          coiffeurappointment_permission: this.user.coiffeurappointment_permission,
          sms_permission: this.user.sms_permission,
          definition_permission: this.user.definition_permission,
          roles: this.user.roles,
          // yearsize_permission: this.user.yearsize_permission,
          // productimage_permission: this.user.productimage_permission,
          company_id: this.$route.params.id ? this.$route.params.id : this.companyid,
        };
        this.updateUser(data).then(response => {
          this.success(response.data.message);
          this.$refs.table.refresh();
          this.$refs.user.hide();
          this.getUser()
        }).catch(error => {
          this.error(error.response.data.message);
        });
      } else {
        const data = JSON.parse(JSON.stringify(this.user));
        data.company_id = this.$route.params.id != undefined ? this.$route.params.id : this.companyid;
        this.createUser(data).then(response => {
          this.success(response.data.message);
          this.$refs.table.refresh();
          this.$refs.user.hide();
        }).catch(error => {
          this.error(error.response.data.message);
        });
      }
    },
    edit(item) {
      this.user = item;
      this.$refs.user.show();
    },
    resetUser() {
      this.user = {
        name: '',
        phone: '',
        email: '',
      };
    },
    items() {
      return this.getUsers(this.$route.params.id ? this.$route.params.id : this.companyid).then(res => {
        res.data=res.data.map(user=>{
          return {...user,roles:user.roles.map(role=>role.name)}
            }
        )
        return res.data;
      });
    },
    deleteAction(id) {
      this.deleteUser(id).then(() => {
        this.$refs.table.refresh();
      })
    }
  },
}
</script>
